import React from 'react';

import { Skeleton } from '@mint-lib/tw-components';

export const ChatHistorySkeleton = () => {
  return (
    <div
      className="flex h-full w-full max-w-200 flex-col gap-5"
      data-testid="chat-history-skeleton"
    >
      <Skeleton variant="rounded" className="h-19" />
      <Skeleton variant="rounded" className="h-4" />
      <Skeleton variant="rounded" className="h-19" />
      <Skeleton variant="rounded" className="h-57" />
      <Skeleton variant="rounded" className="h-19" />
    </div>
  );
};
